export default {
  title: "Microlearningy",
};
